import { LoaderUtil } from "misc/loader";
import { getLanguageString as _ } from "misc/lang";
import { apiVerifyEmail } from "net/requests";
import { signInWithAccessToken } from "misc/auth_utils";
import { DefaultProps } from "model/props";

export const verifyEmail = (
  token: string,
  loader: LoaderUtil,
  accessToken?: string,
  defaultProps?: DefaultProps
) => {
  const heading_failed = _("auth", "email_verify_head_failed");
  const heading = _("auth", "email_verify_head");

  if (!token || token.length < 36) {
    const text = _("auth", "email_verify_token_error");
    loader.setResult(false, heading_failed, text);
    return;
  }

  loader.setLoading();

  apiVerifyEmail(token)
    .then((response) => {
      const text = _("auth", "email_verify_succeded");
      loader.setResult(true, heading, text);
      if (accessToken) signInWithAccessToken(accessToken, defaultProps);
    })
    .catch((error) => {
      const errorReason = error.response?.data?.error;
      console.log("Error: " + errorReason);
      const text = _("auth", "email_verify_failed");
      loader.setResult(false, heading_failed, text);
    });
};

export default verifyEmail;
